import React from 'react';
import { useFormContext } from 'react-hook-form';
import BasePrompt from '../base/prompt/BasePrompt';
import ReactHookFormTextInput from 'components/reactHookFormComponents/ReactHookFormTextInput';

const RequireCampaignNamePrompt = ({
  show,
  onHide,
  onConfirm,
}) => {
  const { watch } = useFormContext();

  const watchName = watch('translations.en.generalName');

  return (
    <BasePrompt
      show={show}
      closeAction={onHide}
      rightButton={{
        text: 'Confirm',
        action: () => onConfirm(true),
        disabled: !watchName,
      }}
      leftButton={{
        text: 'Cancel',
        action: onHide,
      }}
      title={'Reminder'}
      description={'When saving as a draft, you must enter at least campaign name.'}
      otherBody={() => (
        <ReactHookFormTextInput
          valueFieldName='translations.en.generalName'
        />
      )}
    />
  );
};

export default RequireCampaignNamePrompt;
